import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { constant } from "common/constant";
import { postApi } from "common/services/api";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";


const initialState = {
    departments: [],
    loading: false,
    error: null,
    addLoading: false,
};


const departmentSlice = createSlice({
    name: "departments",
    initialState,
    reducers: {
        fetchDepartmentsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchDepartmentsSuccess: (state, action) => {
            state.loading = false;
            state.departments = action.payload;
        },
        fetchDepartmentsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        extraReducers: (builder) => {
            builder
                .addCase(addDepartment.pending, (state) => {
                    state.addLoading = true;
                    state.error = null;
                })
                .addCase(addDepartment.fulfilled, (state) => {
                    state.addLoading = false;
                })
                .addCase(addDepartment.rejected, (state, action) => {
                    state.addLoading = false;
                    state.error = action.payload;
                });
        },
    },
});


export const { fetchDepartmentsStart, fetchDepartmentsSuccess, fetchDepartmentsFailure } = departmentSlice.actions;


export default departmentSlice.reducer;


export const getDepartments = () => async (dispatch) => {
    try {
        dispatch(fetchDepartmentsStart()); 
        const response = await getApi(API_PATHS.RECRUITMENT_DEPARTMENTS);
        dispatch(fetchDepartmentsSuccess(response.data)); 
    } catch (error) {
        dispatch(fetchDepartmentsFailure(error.message || constant.failedToLoadDepartments));
    }
};

export const addDepartment = createAsyncThunk(
    "departments/addDepartment",
    async ({ values, formik, navigate }, { rejectWithValue }) => {
        try {
            const response = await postApi("api/recruitment/departments", values);
            if (response.status === 201) {
                formik.resetForm();
                navigate("/recruit/department"); // Navigate after success
            }
            return response.data;
        } catch (error) {
            return rejectWithValue("Something went wrong");
        }
    }
);